import * as S from "../../constants/StringConstants";

export const validate = values => {
  const errors: any = {};
  if (!values.statusId) {
    errors.statusId = S.APP_FIELD_STATUS_LABEL;
  }
  if (!values.carrierId) {
    errors.carrierId = S.APP_FIELD_CARRIER_LABEL;
  }
  if (!values.productId) {
    errors.productId = S.APP_FIELD_PRODUCT_LABEL;
  }
  if (!values.branchTypeID) {
    errors.branchTypeID = S.APP_BUILDER_ORGANIZATION_LABEL;
  }
  return errors;
};

export const validateAgents = values => {
  const errors: any = { rows: [] };
  let sum = 0;
  let someError = false;
  values.rows.forEach((row, index) => {
    const percentage = parseFloat(row.agentPercentage);
    if (percentage < 0 || percentage > 100) {
      errors.rows[index] = { agentPercentage: "err" };
      someError = true;
    }
    sum += percentage;
  });
  if (sum !== 100 && !someError) {
    values.rows.forEach((_row, index) => {
      errors.rows[index] = { agentPercentage: "err" };
    });
    errors.agents = S.APP_AGENTS_ERROR;
  }

  return errors;
};

export const phoneMask = "(000) 000-0000";
export const zipMask = "00000";
export const ssnMask = "000-00-0000";
